<template>
  <div v-if="communityDetail" class="community-info">
    <div class="visual">
      <v-image v-if="communityDetail.community && communityDetail.community.idImage"
               :image-id="communityDetail.community.idImage"
      />
      <img v-else src="@/assets/DefaultCommunityVisual.png" alt="default-community-visual" />
    </div>
    <div class="header">
      <community-type :community="communityDetail.community" />
      <div class="title">
        <span data-cy="community-title">{{ communityName }}</span>
      </div>
    </div>
    <UserVignette v-if="communityDetail.owner"
                  :user="communityDetail.owner"
                  :top-slot="$t('community.communityInfo.creationInfo', { createdOn: time() })"
    />
    <div class="count-infos">
      <div class="count-item">
        <div class="users">
          <span>{{ communityDetail.countUsers }}</span>
        </div>
        <span class="type">{{ $t('community.communityInfo.users') }}</span>
      </div>
      <div class="count-item">
        <div class="posts">
          <span>{{ communityDetail.countPosts }}</span>
        </div>
        <span class="type">{{ $t('community.communityInfo.posts') }}</span>
      </div>
    </div>
    <div class="description">
      <span>{{ communityDescription }}</span>
    </div>
    <div v-if="isCommunityOwner">
      <div class="link hover-effect" @click="mailtoContent">
        <img src="@/assets/ArrowHLink14.svg" />
        <span>{{ $t('community.communityInfo.invitePeople.link') }}</span>
      </div>
      <div class="link hover-effect">
        <img src="@/assets/ArrowHLink14.svg" />
        <edit-community-button :community="communityDetail.community" />
      </div>
    </div>
    <div v-if="!isCommunityOwner && userIsMember">
      <LeaveCommunityModal :community-id="communityDetail.community.id" />
    </div>
    <div v-if="isAdministrator">
      <NameOwnerModal mode="link"
                      :community-id="communityDetail.community.id"
                      :current-owner-id="communityDetail.idUser"
      />
    </div>
  </div>
</template>

<script>
import VImage from '@/components/shared/VImage'
import CommunityType from '@/components/community/CommunityType'
import EditCommunityButton from '@/components/community/EditCommunityButton'
import LeaveCommunityModal from './LeaveCommunityModal'
import NameOwnerModal from './NameOwnerModal'
import UserVignette from '../user/UserVignette'

export default {
  name: 'CommunityInfo',
  components: {
    EditCommunityButton,
    VImage,
    CommunityType,
    LeaveCommunityModal,
    NameOwnerModal,
    UserVignette
  },
  props: {
    communityDetail: {
      type: Object,
      required: true
    },
    userIsMember: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    time() {
      const createdAt = this.communityDetail.community.createdAt
      return this.$store.getters.getDateFromNow(createdAt)
    },
    mailtoContent() {
      let subject = this.$t('community.communityInfo.invitePeople.subject')
      let body = this.$t('community.communityInfo.invitePeople.body', {
        communityName: this.communityName,
        link: window.location.href,
        ownerFullName: this.communityDetail.owner.firstName + ' ' + this.communityDetail.owner.lastName
      })
      let encodedSubject = encodeURIComponent(subject)
      let encodedBody = encodeURIComponent(body)
      window.location.href = 'mailto:?subject=' + encodedSubject + '&body=' + encodedBody
    }
  },
  computed: {
    communityName() {
      return this.communityDetail.community ? this.communityDetail.community.name : '...'
    },
    communityDescription() {
      return this.communityDetail.community ? this.communityDetail.community.description : '...'
    },
    isCommunityOwner() {
      return this.communityDetail.idUser === this.$store.getters.auth.id
    },
    communityJoinRequests() {
      return this.$store.getters.communityJoinRequests
    },
    isAdministrator() {
      return this.$store.getters.auth.isAdmin
    }
  }
}
</script>

<style scoped lang="scss">
.community-info {
  height: fit-content;
  background-color: #FFFFFF;
  box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.2);
  padding-bottom: 1rem;
  @media (max-width: $header-change) {
    width: 100%;
    margin: 0;
  }
}

.link {
  color: $tertiary-color;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 1.2rem;

  &:hover {
    text-decoration: underline;
  }
}

.text {
  text-align: left;
  color: $black-color;
}

.visual img {
  width: 291px;
  height: 163px;
  object-fit: cover;
  object-position: 20% 20%;
  max-width: 100%;
}

.header {
  display: flex;
  font-size: 18px;
  color: $black-color;
  font-weight: 600;
  margin: 10px 10px 10px 5px;
  align-items: flex-start;

  .title {
    width: 100%;
    text-align: left;

    span {
      margin-left: 10px;
    }
  }

}

.author {
  display: flex;
  margin: 0.5rem 24px;
  align-items: center;

  .user-photo {
    height: 3rem;
    border-radius: 100%;
  }

  .author-description {
    display: flex;
    flex-direction: column;
    text-align: left;
    margin: 0 0.7rem;

    font-size: 13px;
    line-height: 19px;

    .author-name {
      font-size: 14px;
      line-height: 21px;
      font-weight: bold;
    }

    .author-job {
      font-size: 13px;
      line-height: 19px;
      font-weight: normal;
    }
  }
}

.count-infos {
  display: flex;
  flex-direction: row;
  justify-content: center;
  // margin-left: 3rem;
  font-size: 14px;

  .count-item {
    margin: 1rem;

    .posts,
    .users {
      margin: auto;
      align-items: center;
      justify-content: center;
      display: flex;
      flex-direction: column;
      width: 46px;
      height: 46px;
      background-color: #d8d8d8;
      border-radius: 100%;
      font-size: 20px;
      font-weight: bold;

      .type {
        font-size: 10px;
        font-weight: 200;
      }
    }
  }
}

.description {
  margin: 0.5rem 1.5rem 1.5rem 1.5rem;
  display: flex;
  text-align: left;
}

.edit-button {
  margin-top: 16px;
}

</style>
